import React, { Fragment } from 'react';
import {FormattedHTMLMessage} from 'react-intl';
import { withRouter } from 'react-router-dom';
import './cookiePolicy.scss';

const CookiePolicyVM = () => {
  // const cookiePolicyVMManually = () => {
  //   // localStorage.setItem('cookie_policy_manual', 1);
  //   Optanon.ToggleInfoDisplay();
  // };

  return (
    <Fragment>
      <div className="cookie-policy-vm-wrapper">
        <div className="cookie-policy-vm-inner">
          <FormattedHTMLMessage
            id='cookie_policy.cookie_policy_vm'
            defaultMessage="We have disabled Cookies by default, to change, kindly update in this Cookie preference center <span id='ot-sdk-btn' className='ot-sdk-show-settings nolink'>Cookie Settings</span>"
          />
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(CookiePolicyVM);
